import {Reducer} from 'redux';

import {isShallowEqual} from '../helpers/reselectHelpers';
import {AppAction} from './appActions';
import {AppState} from './appState';
import {createDataCascade, DataCascade} from './data/dataCascade';
import {electronReducer} from './electron/electronReducer';
import {featureFlagsReducer} from './featureFlags/featureFlagsReducer';
import {metadataReducer} from './metadata/metadataReducer';
import {dataWithOptimisticUpdatesReducer} from './optimisticUpdates/optimisticUpdatesReducer';
import {panelsReducer} from './panels/panelsReducer';
import {updateReducer} from './update/updateReducer';

export const appReducer: Reducer<AppState, AppAction> = (prevState, action) => {
  // Step 1: reduce the data state and re-apply optimistic updates.
  const nextDataWithOptimisticUpdatesState = dataWithOptimisticUpdatesReducer(prevState, action);

  // Allow data state changes to impact the panel state.
  const dataCascade: DataCascade = createDataCascade(
    prevState?.data,
    nextDataWithOptimisticUpdatesState.data,
  );

  // Step 2: reduce everything else.
  const nextState: AppState = {
    ...nextDataWithOptimisticUpdatesState,
    metadata: metadataReducer(prevState && prevState.metadata, action),
    panels: panelsReducer(prevState && prevState.panels, action, dataCascade),
    featureFlags: featureFlagsReducer(prevState && prevState.featureFlags, action),
    electron: electronReducer(prevState && prevState.electron, action),
    update: updateReducer(prevState && prevState.update, action),
  };

  // Avoid changing the identity of the state object, equivalent to combineReducers().
  if (prevState && isShallowEqual(prevState, nextState)) {
    return prevState;
  }

  return nextState;
};
